import React from 'react'
import PropTypes from 'prop-types'

import {VIEW_FULL, VIEW_PANNEL, VIEW_PREVIEW} from '../../constants';
import SearchViewFull from '../../views/SearchViewFull';
import SearchViewPreview from '../../views/SearchViewPreview';
import SearchViewPannel from '../../views/SearchViewPannel';

const mapViews = {
  [VIEW_FULL]: SearchViewFull,
  [VIEW_PREVIEW]: SearchViewPreview,
  [VIEW_PANNEL]: SearchViewPannel,
  'default': SearchViewPannel,
}

const ViewByKey = function ({view, children, ...props}) {
  const ViewComponent = view in mapViews ? mapViews[view] : mapViews.default;
  return (<ViewComponent {...props}>{children}</ViewComponent>)
}

ViewByKey.propTypes = {
  view: PropTypes.oneOf(Object.keys(mapViews)),
}

export default ViewByKey;
